//项目初始化（画布id号）
var MMS3D_newCanvas = function (id, td = function () { console.log('场景加载完成') }) {
	let urlD = './'
	var MMS_container = document.getElementById(id);	//三维画布

	var div = document.createElement("div");
	div.setAttribute("id", "MMS3D_DIV");
	div.setAttribute("TUrl", urlD);
	div.setAttribute("style", "width:100%;height:100%;");
	div.innerHTML = `<iframe id="idFrame" name="idFrame" src="./MMS3D/3D/index.html"  style = "width: 100%;height: 100%;border: 0;position: absolute;top: 0;left: 0;display: block;" ></iframe>`;
	MMS_container.appendChild(div);

	document.getElementById('idFrame').contentWindow.onload = function () {
		let dddd = setInterval(() => {
			let dtype = document.getElementById("idFrame").contentWindow.MMS3D_ready()
			if (dtype) {
				td();
				clearInterval(dddd);
			}
		}, 1000);
	}
}


//外部函数接口
var MMS3D_API = {
	clear3D_canvas() {          //清除三维场景内存
		if (!!document.getElementById("MMS3D_DIV")) {
			var box = document.getElementById("MMS3D_DIV");
			box.parentNode.removeChild(box);
		}
	},
}


export { MMS3D_newCanvas, MMS3D_API };